import { render, staticRenderFns } from "./FormattedMinutesComponent.vue?vue&type=template&id=4935daa7&"
import script from "./FormattedMinutesComponent.vue?vue&type=script&lang=js&"
export * from "./FormattedMinutesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4935daa7')) {
      api.createRecord('4935daa7', component.options)
    } else {
      api.reload('4935daa7', component.options)
    }
    module.hot.accept("./FormattedMinutesComponent.vue?vue&type=template&id=4935daa7&", function () {
      api.rerender('4935daa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formatted/FormattedMinutesComponent.vue"
export default component.exports